module.exports = require("npm:async.util.noop@0.5.2/index.js");